// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AyOhh","buttons":"styles_buttons__1JlUn"};